/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SchedulePublishReviewRequest } from '../models/SchedulePublishReviewRequest';
import type { ScheduleWeekConfirmRequest } from '../models/ScheduleWeekConfirmRequest';
import type { ScheduleWeekRemindRequest } from '../models/ScheduleWeekRemindRequest';
import type { ShiftTemplateCreateRequest } from '../models/ShiftTemplateCreateRequest';
import type { ShiftTemplateUpdateRequest } from '../models/ShiftTemplateUpdateRequest';
import type { SuccessResponse_MyScheduleResponse_ } from '../models/SuccessResponse_MyScheduleResponse_';
import type { SuccessResponse_ScheduleChangeActiveListResponse_ } from '../models/SuccessResponse_ScheduleChangeActiveListResponse_';
import type { SuccessResponse_ScheduleChangeContextResponse_ } from '../models/SuccessResponse_ScheduleChangeContextResponse_';
import type { SuccessResponse_ScheduleCopyPreviewResponse_ } from '../models/SuccessResponse_ScheduleCopyPreviewResponse_';
import type { SuccessResponse_SchedulePublishReviewResponse_ } from '../models/SuccessResponse_SchedulePublishReviewResponse_';
import type { SuccessResponse_ScheduleWeekConfirmationListResponse_ } from '../models/SuccessResponse_ScheduleWeekConfirmationListResponse_';
import type { SuccessResponse_ScheduleWeekConfirmResponse_ } from '../models/SuccessResponse_ScheduleWeekConfirmResponse_';
import type { SuccessResponse_ScheduleWeekOverviewResponse_ } from '../models/SuccessResponse_ScheduleWeekOverviewResponse_';
import type { SuccessResponse_ScheduleWeekRemindResponse_ } from '../models/SuccessResponse_ScheduleWeekRemindResponse_';
import type { SuccessResponse_ShiftSwapCandidateListResponse_ } from '../models/SuccessResponse_ShiftSwapCandidateListResponse_';
import type { SuccessResponse_ShiftTemplateData_ } from '../models/SuccessResponse_ShiftTemplateData_';
import type { SuccessResponse_ShiftTemplateListResponse_ } from '../models/SuccessResponse_ShiftTemplateListResponse_';
import type { SuccessResponse_WeekScheduleResponse_ } from '../models/SuccessResponse_WeekScheduleResponse_';
import type { SuccessResponse_WeekScheduleSaveResponse_ } from '../models/SuccessResponse_WeekScheduleSaveResponse_';
import type { WeekScheduleSaveRequest } from '../models/WeekScheduleSaveRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SchedulesService {
    /**
     * Get Week Overview Endpoint
     * GET /api/v1/schedules/week-overview — visible-store weekly status.
     * @returns SuccessResponse_ScheduleWeekOverviewResponse_ Successful Response
     * @throws ApiError
     */
    public static getWeekOverviewEndpointApiV1SchedulesWeekOverviewGet({
        weekStart,
    }: {
        weekStart: string,
    }): CancelablePromise<SuccessResponse_ScheduleWeekOverviewResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/schedules/week-overview',
            query: {
                'week_start': weekStart,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Shift Templates Endpoint
     * GET /api/v1/stores/{store_id}/shift-templates.
     * @returns SuccessResponse_ShiftTemplateListResponse_ Successful Response
     * @throws ApiError
     */
    public static listShiftTemplatesEndpointApiV1StoresStoreIdShiftTemplatesGet({
        storeId,
    }: {
        storeId: number,
    }): CancelablePromise<SuccessResponse_ShiftTemplateListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores/{store_id}/shift-templates',
            path: {
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Shift Template Endpoint
     * POST /api/v1/stores/{store_id}/shift-templates — 店长创建本店班次.
     * @returns SuccessResponse_ShiftTemplateData_ Successful Response
     * @throws ApiError
     */
    public static createShiftTemplateEndpointApiV1StoresStoreIdShiftTemplatesPost({
        storeId,
        requestBody,
    }: {
        storeId: number,
        requestBody: ShiftTemplateCreateRequest,
    }): CancelablePromise<SuccessResponse_ShiftTemplateData_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/stores/{store_id}/shift-templates',
            path: {
                'store_id': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Shift Template Endpoint
     * PATCH /api/v1/shift-templates/{shift_template_id} — 编辑/停用班次.
     * @returns SuccessResponse_ShiftTemplateData_ Successful Response
     * @throws ApiError
     */
    public static updateShiftTemplateEndpointApiV1ShiftTemplatesShiftTemplateIdPatch({
        shiftTemplateId,
        requestBody,
    }: {
        shiftTemplateId: number,
        requestBody: ShiftTemplateUpdateRequest,
    }): CancelablePromise<SuccessResponse_ShiftTemplateData_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/shift-templates/{shift_template_id}',
            path: {
                'shift_template_id': shiftTemplateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Week Schedule Endpoint
     * GET /api/v1/stores/{store_id}/schedules/week — 查看门店周排班.
     * @returns SuccessResponse_WeekScheduleResponse_ Successful Response
     * @throws ApiError
     */
    public static getWeekScheduleEndpointApiV1StoresStoreIdSchedulesWeekGet({
        storeId,
        weekStart,
    }: {
        storeId: number,
        weekStart: string,
    }): CancelablePromise<SuccessResponse_WeekScheduleResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores/{store_id}/schedules/week',
            path: {
                'store_id': storeId,
            },
            query: {
                'week_start': weekStart,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Save Week Schedule Endpoint
     * PUT /api/v1/stores/{store_id}/schedules/week — 批量保存本周排班.
     * @returns SuccessResponse_WeekScheduleSaveResponse_ Successful Response
     * @throws ApiError
     */
    public static saveWeekScheduleEndpointApiV1StoresStoreIdSchedulesWeekPut({
        storeId,
        requestBody,
    }: {
        storeId: number,
        requestBody: WeekScheduleSaveRequest,
    }): CancelablePromise<SuccessResponse_WeekScheduleSaveResponse_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/stores/{store_id}/schedules/week',
            path: {
                'store_id': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Copy Previous Week Preview Endpoint
     * @returns SuccessResponse_ScheduleCopyPreviewResponse_ Successful Response
     * @throws ApiError
     */
    public static copyPreviousWeekPreviewEndpointApiV1StoresStoreIdSchedulesCopyPreviousPreviewGet({
        storeId,
        targetWeekStart,
    }: {
        storeId: number,
        targetWeekStart: string,
    }): CancelablePromise<SuccessResponse_ScheduleCopyPreviewResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores/{store_id}/schedules/copy-previous-preview',
            path: {
                'store_id': storeId,
            },
            query: {
                'target_week_start': targetWeekStart,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Schedule Change Context Endpoint
     * GET management-staff schedule entry capability from reporting lines.
     * @returns SuccessResponse_ScheduleChangeContextResponse_ Successful Response
     * @throws ApiError
     */
    public static getScheduleChangeContextEndpointApiV1StoresStoreIdScheduleChangeRequestsContextGet({
        storeId,
    }: {
        storeId: number,
    }): CancelablePromise<SuccessResponse_ScheduleChangeContextResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores/{store_id}/schedule-change-requests/context',
            path: {
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Active Schedule Change Requests Endpoint
     * GET active schedule-change cells for one visible week.
     * @returns SuccessResponse_ScheduleChangeActiveListResponse_ Successful Response
     * @throws ApiError
     */
    public static listActiveScheduleChangeRequestsEndpointApiV1StoresStoreIdScheduleChangeRequestsActiveGet({
        storeId,
        weekStart,
    }: {
        storeId: number,
        weekStart: string,
    }): CancelablePromise<SuccessResponse_ScheduleChangeActiveListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores/{store_id}/schedule-change-requests/active',
            path: {
                'store_id': storeId,
            },
            query: {
                'week_start': weekStart,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Week Schedule Endpoint
     * GET /api/v1/stores/{store_id}/schedules/week/export — 周排班表 xlsx.
     * @returns binary 周排班表 xlsx
     * @throws ApiError
     */
    public static exportWeekScheduleEndpointApiV1StoresStoreIdSchedulesWeekExportGet({
        storeId,
        weekStart,
        keyword = '',
        position = 'all',
        status = 'all',
    }: {
        storeId: number,
        weekStart: string,
        keyword?: string,
        position?: string,
        status?: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores/{store_id}/schedules/week/export',
            path: {
                'store_id': storeId,
            },
            query: {
                'week_start': weekStart,
                'keyword': keyword,
                'position': position,
                'status': status,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Month Schedule Endpoint
     * GET /api/v1/stores/{store_id}/schedules/month/export — 月排班表 xlsx.
     *
     * 与周导出同一个 ``SCHEDULE_WEEK_READ`` 资格和同一个门店守卫 (门店范围由
     * ``get_week_schedule`` 里的 ``resolve_schedule_week_access`` 判)。⛔ 不新增编辑/发布、
     * 跨店或看到原本不可见草稿的资格。非法年月由 Query 约束直接 422, ⛔ 不隐式滚到另一月。
     * @returns binary 月排班表 xlsx
     * @throws ApiError
     */
    public static exportMonthScheduleEndpointApiV1StoresStoreIdSchedulesMonthExportGet({
        storeId,
        year,
        month,
        keyword = '',
        position = 'all',
        status = 'all',
    }: {
        storeId: number,
        year: number,
        month: number,
        keyword?: string,
        position?: string,
        status?: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores/{store_id}/schedules/month/export',
            path: {
                'store_id': storeId,
            },
            query: {
                'year': year,
                'month': month,
                'keyword': keyword,
                'position': position,
                'status': status,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Preview Week Publish Endpoint
     * Read the current published values for exactly the assignments being reviewed.
     * @returns SuccessResponse_SchedulePublishReviewResponse_ Successful Response
     * @throws ApiError
     */
    public static previewWeekPublishEndpointApiV1StoresStoreIdSchedulesPublishReviewPost({
        storeId,
        requestBody,
    }: {
        storeId: number,
        requestBody: SchedulePublishReviewRequest,
    }): CancelablePromise<SuccessResponse_SchedulePublishReviewResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/stores/{store_id}/schedules/publish-review',
            path: {
                'store_id': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Week Confirmations Endpoint
     * GET /api/v1/stores/{store_id}/schedules/week/confirmations.
     * @returns SuccessResponse_ScheduleWeekConfirmationListResponse_ Successful Response
     * @throws ApiError
     */
    public static listWeekConfirmationsEndpointApiV1StoresStoreIdSchedulesWeekConfirmationsGet({
        storeId,
        weekStart,
        status = 'all',
    }: {
        storeId: number,
        weekStart: string,
        status?: 'all' | 'pending' | 'confirmed',
    }): CancelablePromise<SuccessResponse_ScheduleWeekConfirmationListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores/{store_id}/schedules/week/confirmations',
            path: {
                'store_id': storeId,
            },
            query: {
                'week_start': weekStart,
                'status': status,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Remind Unconfirmed Endpoint
     * POST /api/v1/stores/{store_id}/schedules/week/remind-unconfirmed.
     * @returns SuccessResponse_ScheduleWeekRemindResponse_ Successful Response
     * @throws ApiError
     */
    public static remindUnconfirmedEndpointApiV1StoresStoreIdSchedulesWeekRemindUnconfirmedPost({
        storeId,
        requestBody,
    }: {
        storeId: number,
        requestBody: ScheduleWeekRemindRequest,
    }): CancelablePromise<SuccessResponse_ScheduleWeekRemindResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/stores/{store_id}/schedules/week/remind-unconfirmed',
            path: {
                'store_id': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get My Schedule Endpoint
     * GET /api/v1/schedules/me — 员工/店长查看自己的排班.
     * @returns SuccessResponse_MyScheduleResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyScheduleEndpointApiV1SchedulesMeGet({
        weekStart,
    }: {
        weekStart: string,
    }): CancelablePromise<SuccessResponse_MyScheduleResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/schedules/me',
            query: {
                'week_start': weekStart,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List My Shift Swap Candidates Endpoint
     * GET /api/v1/schedules/me/shift-swap-candidates — 员工可申请换班的同店候选.
     * @returns SuccessResponse_ShiftSwapCandidateListResponse_ Successful Response
     * @throws ApiError
     */
    public static listMyShiftSwapCandidatesEndpointApiV1SchedulesMeShiftSwapCandidatesGet({
        weekStart,
        sourceWorkDate,
    }: {
        weekStart: string,
        sourceWorkDate: string,
    }): CancelablePromise<SuccessResponse_ShiftSwapCandidateListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/schedules/me/shift-swap-candidates',
            query: {
                'week_start': weekStart,
                'source_work_date': sourceWorkDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Confirm My Week Endpoint
     * POST /api/v1/schedules/me/confirm-week — 员工确认自己的本周排班.
     * @returns SuccessResponse_ScheduleWeekConfirmResponse_ Successful Response
     * @throws ApiError
     */
    public static confirmMyWeekEndpointApiV1SchedulesMeConfirmWeekPost({
        requestBody,
    }: {
        requestBody: ScheduleWeekConfirmRequest,
    }): CancelablePromise<SuccessResponse_ScheduleWeekConfirmResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/schedules/me/confirm-week',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
